export default __webpack_public_path__ + "static/media/CarouselArrowLeft.7e99a2c9.svg";